import React, { useEffect, useState } from "react";
import * as Styled from "./RollAdsModalForm.styled";
import { Col, Spinner } from "react-bootstrap";
import Select from "react-select";
import { TextInput, Error, BaseButton } from "../../../../../libs";
import { DragAndDropZone } from "../../../../drag-drop-zone";
import { RollAdsModalCard } from "../roll-ads-form-card";
import { IRollAdsModalFormProps } from "../../../../../libs/models/ad-server";

export const RollAdsModalForm: React.FC<IRollAdsModalFormProps> = ({ formik, onDropHandler, handleVisibilityToggle, displayOptions, uploadedFile, setUploadedFiles, handleDeleteFile, isEdit = false, adsType, setAdsType, resetForm, onClose, percentage }) => {
  const [count, setCount] = useState(isEdit ? true : false);
  function mergeArraysUnique(arr1, arr2) {
    const map = new Map();

    [...arr2, ...arr1].forEach(item => {
      let key = item.s3Key || item.previewUrl || item.file?.path; 
      if (!map.has(key)) {
        map.set(key, item);
      }
    });

    return Array.from(map.values());
  }
  useEffect(() => {
    if (formik.values.videoFiles) {
      setUploadedFiles(mergeArraysUnique(formik.values.videoFiles, uploadedFile))
    }
  }, [formik.values.videoFiles]);

  const handleTypeChange = (index: number, newType: string) => {
    setUploadedFiles((prev) => {
      const updatedFiles = prev.map((file, idx) =>
        idx === index ? { ...file, fileType: newType } : file
      );
      return updatedFiles;
    });
  };



  const handleInvalidFormat = React.useCallback(() => {
    alert("Supported formats: .mp4, .ogv, .webm, .mov, .mkv, .wmv, .mpeg, .m4v, .webm, .m2ts, .m3u8, .mxf, .h264");
  }, []);

  const isFileSelectorVisible = () => {
    if (uploadedFile.length === 0) return true;
    if (uploadedFile.length >= 10) return false;

    const { videoFiles } = formik.errors;
    return !(videoFiles?.includes("Please select at least one ad type option")) ||
      videoFiles?.includes("The following files are too large (max 20MB):");
  };

  return (
    <Styled.FormMainWrapper>
      {formik.isSubmitting && (
        <Styled.LoaderWrapper>
          <Spinner animation="border" size="sm" /> <span>Saving...</span>
        </Styled.LoaderWrapper>
      )}


      <Styled.FormWrapper>
        <Styled.FormTitle>{isEdit ? 'Update Campaign' : 'New Campaign'}</Styled.FormTitle>
        <form onSubmit={formik.handleSubmit} noValidate>
          {/* Campaign Name Input */}
          <Col>
            <TextInput
              fieldName="title"
              fieldLabel="Campaign Name"
              placeholder="Add name here"
              fieldValue={formik.values.title}
              onChangeHandler={formik.handleChange}
              onBlurHandler={formik.handleBlur}
              hasError={formik.touched.title && !!formik.errors.title}
            />
            {formik.touched.title && formik.errors.title && <Error message={formik.errors.title} />}
          </Col>

          {/* Ad Video File Upload */}
          <Styled.AdVideoTitle>Ad video file</Styled.AdVideoTitle>

          <RollAdsModalCard
            formik={formik}
            uploadedFile={uploadedFile}
            handleDeleteFile={handleDeleteFile}
            setCount={setCount}
            count={count}
            adsType={adsType}
            setAdsType={setAdsType}
            setUploadedFiles={setUploadedFiles}
            handleTypeChange={handleTypeChange}
          />

          {count || uploadedFile.length === 0 ? (
            <Styled.DragDropWrapper>
              {isFileSelectorVisible() && (
                <Col>
                  <DragAndDropZone
                    showSmallImage
                    direction="horizontal"
                    textalign="left"
                    dropMessageText="Drag and drop here your ROLL AD or choose file. Video 1920 x 1080. Max 100 MB each (mp4; <60 secs)"
                    acceptedFileType="video/*"
                    onDropHandler={onDropHandler}
                    setCount={setCount}
                    count={count}
                    onInvalidFormatError={handleInvalidFormat}
                  />
                  {formik.errors.videoFiles && (
                    <Styled.ErrorText>
                      {Array.isArray(formik.errors.videoFiles)
                        ? formik.errors.videoFiles.join(", ")
                        : formik.errors.videoFiles}
                    </Styled.ErrorText>
                  )}
                </Col>
              )}
            </Styled.DragDropWrapper>
          ) : null}


          <Col>
            <Styled.SectionTitle>Where to display it</Styled.SectionTitle>
            <Styled.SubTitle>Select a playlist or videos in which this campaign will be active.</Styled.SubTitle>
          </Col>
          <Col>
            <Styled.SectionCustomSelect>
              <Select
                className="custom-select"
                isMulti
                menuPlacement="auto"
                styles={Styled.selectStyles}
                menuShouldScrollIntoView={false}
                placeholder="Select playlist or videos here"
                value={displayOptions.filter((opt) => formik.values.displayOption.includes(opt.value))}
                options={displayOptions}
                isClearable
                onChange={(selectedOptions) => formik.setFieldValue("displayOption", selectedOptions.map((opt) => opt.value))}

              />
            </Styled.SectionCustomSelect>
            {formik.touched.displayOption && formik.errors.displayOption && (
              <Error message="Select one of video or playlist" />
            )}
          </Col>

          {/* Visibility Toggle */}
          <Styled.VisibilityWrapper>
            <Styled.VisibilityTextWrapper>
              <Styled.SectionTitle>Visibility</Styled.SectionTitle>
              <Styled.SubTitle>Choose when to publish.</Styled.SubTitle>
            </Styled.VisibilityTextWrapper>
            <Styled.CustomSwitch checked={formik.values.isVisible} onChange={handleVisibilityToggle} />
          </Styled.VisibilityWrapper>

          <Styled.FormFieldRow>
            <Col>
              <Styled.TransparentButton variant="secondary" onClick={() => {
                resetForm();
                onClose();
              }}>Go Back</Styled.TransparentButton>
            </Col>
            <Col>

              <BaseButton
                type="submit"
                disabled={false}
              >
                {formik.isSubmitting ? (
                  isEdit ? (
                    "Processing"
                  ) : (
                    <>
                      <Styled.LoadingSpinner animation="border" size="sm" variant="primary" />
                      {percentage}% Uploaded
                    </>
                  )
                ) : (
                  percentage === 100 ? "Processing" : (isEdit ? "Update Campaign" : "Save Campaign")
                )}
              </BaseButton>

            </Col>
          </Styled.FormFieldRow>
        </form>
      </Styled.FormWrapper>
    </Styled.FormMainWrapper>
  );
};


